<div class="d-flex justify-content-center">
  <div class="row">
    <div class="col-12 d-flex justify-content-center pt-3 mt-1">
      @if (authService.hasMultipleCreateFlow) {
        <button
          class="btn btn-primary btn-capsule"
          [routerLink]="`/${authService.companyUrl}/create/choose/customer`"
          [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
          <span>{{ '$button_create_customer$' | translate }}</span>
          <i class="material-icons mi-inline">person</i>
        </button>
      } @else {
        <button
          class="btn btn-primary btn-capsule"
          [routerLink]="`/${authService.companyUrl}/create/move/customer`"
          [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
          <span>{{ '$button_create_customer$' | translate }}</span>
          <i class="material-icons mi-inline">person</i>
        </button>
      }
    </div>
    <div class="col-12 text-center pt-3 mt-1">
      <p class="mb-0">{{ '$createassignment_title$' | translate }}</p>
    </div>
    <div class="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end pt-3 mt-1">
      @if (authService.hasMultipleCreateFlow) {
        <button
          class="btn btn-primary btn-capsule"
          [routerLink]="`/${authService.companyUrl}/create/choose/agent`"
          [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
          <span>{{ '$button_create_new_partner$' | translate }}</span>
          <i class="material-icons mi-inline">business</i>
        </button>
      } @else {
        <button
          class="btn btn-primary btn-capsule"
          [routerLink]="`/${authService.companyUrl}/create/move/agent`"
          [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
          <span>{{ '$button_create_new_partner$' | translate }}</span>
          <i class="material-icons mi-inline">business</i>
        </button>
      }
    </div>
    <div class="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-start pt-3 mt-1">
      @if (authService.hasMultipleCreateFlow) {
        <button
          class="btn btn-primary btn-capsule"
          [routerLink]="`/${authService.companyUrl}/create/choose/account`"
          [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
          <span>{{ '$button_create_new_account$' | translate }}</span>
          <i class="material-icons mi-inline">account_box</i>
        </button>
      } @else {
        <button
          class="btn btn-primary btn-capsule"
          [routerLink]="`/${authService.companyUrl}/create/move/account`"
          [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
          <span>{{ '$button_create_new_account$' | translate }}</span>
          <i class="material-icons mi-inline">account_box</i>
        </button>
      }
    </div>
  </div>
</div>
